import Home from "./Layout/Home";
import { Box } from "@mui/material";

import Hotjar from "@hotjar/browser";
import AnimatedCursor from "react-animated-cursor";
import useMediaQuery from '@mui/material/useMediaQuery';

function App() {
  const siteId = 5066209;
  const hotjarVersion = 6;

  Hotjar.init(siteId, hotjarVersion);

  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box className="App" style={{ backgroundColor: "#222831" }}>
      <Home />
      {!isMobile && (
        <AnimatedCursor
          innerSize={8}
          outerSize={35}
          innerScale={1}
          outerScale={2}
          outerAlpha={0}
          hasBlendMode={true}
          innerStyle={{
            backgroundColor: "#fff",
          }}
          outerStyle={{
            border: "3px solid #fff",
          }}
        />
      )}
    </Box>
  );
}

export default App;
